import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "banner-indicator" }
const _hoisted_2 = { class: "banner-indicator-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BannerIndicatorItem = _resolveComponent("BannerIndicatorItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
        return (_openBlock(), _createBlock(_component_BannerIndicatorItem, {
          class: "banner-indicator-item",
          key: item.id,
          active: _ctx.isActive(item.id)
        }, null, 8, ["active"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}